<script setup lang="ts">
import type { NavigationMenuItem } from "@nuxt/ui";

const { $auth } = useNuxtApp();

const collapse = ref<boolean>(true);

const verticalMenu: NavigationMenuItem[][] = [
  [
    {
      label: "کلاس درس",
      to: { name: "index" },
      icon: "i-solar-music-notes-linear",
    },
    {
      label: "دوره‌های‌من",
      to: { name: "courses" },
      icon: "i-solar-music-library-2-linear",
    },
    {
      label: "پیام‌ها",
      to: { name: "profile-tickets" },
      icon: "i-solar-chat-round-linear",
    },

    {
      label: "پروفایل",
      to: "/profile",
      avatar: {
        src: $auth.user?.avatar ?? "",
        alt: $auth.user
          ? (($auth.user?.firstName + $auth.user?.lastName) as string)
          : "",
      },
    },
  ],
];

const horizontalMenu: NavigationMenuItem[][] = [
  [
    {
      label: "کلاس درس",
      to: { name: "index" },
      icon: "i-solar-music-notes-linear",
    },
    {
      label: "دوره‌های‌من",
      to: { name: "courses" },
      icon: "i-solar-music-library-2-linear",
    },
    {
      label: "پیام‌ها",
      to: { name: "profile-tickets" },
      icon: "i-solar-chat-round-linear",
    },
  ]
];

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} | خنیاگر` : "خنیاگر";
  },
  htmlAttrs: {
    lang: "fa-IR",
    dir: "rtl",
  },
  bodyAttrs: {
    class: "bg-neutral-100 dark:bg-neutral-950",
  },
});
</script>

<template>
  <UApp dir="rtl" :toaster="{ position: 'top-center' }">
    <NuxtLoadingIndicator />

    <UDashboardGroup unit="rem" :persistent="false">
      <UDashboardPanel
        id="root-panel"
        :ui="{
          root: 'min-h-full h-full w-full lg:h-full lg:min-h-full overflow-auto flex-1',
          body: 'p-0 m-0',
        }"
      >
        <UDashboardNavbar
          class="hidden lg:flex lg:px-[10vw] bg-neutral-50 dark:bg-neutral-900"
        >
          <template #left>
            <UNavigationMenu :items="horizontalMenu[0]" />
          </template>

          <template #right>
            <NuxtLink :to="{ name: 'profile' }">
              <UAvatar :width="250" :height="250" :src="$auth.user?.avatar ?? ''" :alt="$auth.user ? (($auth.user?.firstName + $auth.user?.lastName) as string) : 'خ'" size="lg" />
            </NuxtLink>
          </template>
        </UDashboardNavbar>
        <NuxtPage />
      </UDashboardPanel>

      <div
        dir="rtl"
        class="h-dvh portrait:hidden lg:hidden flex items-center justify-center py-2 pl-2"
      >
        <UButton
          size="md"
          class="cursor-pointer flex items-center justify-center h-full w-7 text-neutral-400 dark:text-neutral-200 bg-neutral-200 dark:bg-neutral-400 "
          :to="{ name: 'courses' }"
        >
          <div class="flex flex-row gap-2 -rotate-90">
            <UIcon
              class="mt-0.5"
              name="i-solar-arrow-to-top-left-linear"
            />
            <span>بازگشت</span>
          </div>
        </UButton>
      </div>

      <UDashboardSidebar
        v-model:collapsed="collapse"
        dir="rtl"
        class="bg-neutral-50 dark:bg-neutral-900 landscape:hidden"
      >
        <template #default="{ collapsed }">
          <UNavigationMenu
            dir="rtl"
            :collapsed
            :items="verticalMenu[0]"
            orientation="horizontal"
            class="w-full p-0 gap-0 m-0 items-center justify-center"
            :ui="{
              root: 'w-full flex flex-1 [&>div]:w-full [&>div]:min-w-0',
              item: 'flex  w-full ',
              link: 'gap-1 flex-col ',
              linkLabel: 'text-xs ',
            }"
          />
        </template>
      </UDashboardSidebar>
    </UDashboardGroup>
  </UApp>
</template>
